document.addEventListener("DOMContentLoaded", () => {
  // Wir geben teeinblue 2 Sekunden Zeit, um auf dem Handy vollständig zu laden
  setTimeout(() => {
    // Wenn der Bildschirm größer als ein Tablet ist, brich ab (nur für Mobile!)
    if (window.innerWidth >= 768) return; 

    // Die Container aus deinem Pitch-Theme
    const galleryWrapper = document.querySelector(".product-information__media");
    const galleryContent = document.querySelector(".product-information__media .tee-gallery-content");

    if (!galleryWrapper || !galleryContent) return;

    // 1. Das hartnäckige CSS für Mobile einfügen
    const style = document.createElement("style");
    style.innerHTML = `
      /* Das schwebende Fenster - fixiert oben rechts */
      body.tee-is-sticky .tee-gallery-content {
        position: fixed !important;
        top: 80px !important; /* Abstand von oben, falls du einen fixierten Header hast */
        right: 15px !important;
        left: auto !important; /* WICHTIG: Verhindert, dass es sich über den ganzen Bildschirm zieht */
        width: 40vw !important;  /* Exakt 40% der Bildschirmbreite */
        height: 40vw !important; /* Höhe ebenfalls 40vw, damit es schön quadratisch bleibt */
        z-index: 99999 !important;
        background: #ffffff !important;
        border-radius: 8px !important;
        box-shadow: 0 4px 15px rgba(0,0,0,0.2) !important;
        padding: 5px !important;
      }

      /* Die inneren teeinblue-Elemente zwingen, in die kleine Box zu passen */
      body.tee-is-sticky .tee-gallery-content .tee-gallery,
      body.tee-is-sticky .tee-gallery-content .tee-slider,
      body.tee-is-sticky .tee-gallery-content .tee-slider__inner,
      body.tee-is-sticky .tee-gallery-content .tee-slide {
        width: 100% !important;
        height: 100% !important;
        min-height: 0 !important;
        transform: none !important;
      }

      /* Das Bild/Canvas selbst so skalieren, dass nichts abgeschnitten wird */
      body.tee-is-sticky .tee-gallery-content canvas,
      body.tee-is-sticky .tee-gallery-content img {
        width: 100% !important;
        height: 100% !important;
        max-width: 100% !important;
        object-fit: contain !important; /* Verhindert das Abschneiden der Ränder */
      }

      /* Störende Punkte und Thumbnails ausblenden */
      body.tee-is-sticky .tee-gallery-content .tee-slider__dots,
      body.tee-is-sticky .tee-gallery-content .tee-thumbnails,
      body.tee-is-sticky .tee-gallery-content button {
        display: none !important;
      }
    `;
    document.head.appendChild(style);

    // 2. Die Scroll-Logik
    const onScroll = () => {
      // Wo befindet sich das Original-Bild gerade?
      const wrapperRect = galleryWrapper.getBoundingClientRect();
      
      // Wenn der untere Rand des Bildes droht, aus dem sichtbaren Bereich zu verschwinden
      if (wrapperRect.bottom < 80) {
        if (!document.body.classList.contains("tee-is-sticky")) {
          // WICHTIGER TRICK: Wir geben dem leeren Platz eine feste Höhe, damit die Eingabefelder nicht nach oben springen!
          galleryWrapper.style.height = galleryWrapper.offsetHeight + "px";
          document.body.classList.add("tee-is-sticky");
        }
      } else {
        // Wenn man wieder nach oben scrollt
        if (document.body.classList.contains("tee-is-sticky")) {
          document.body.classList.remove("tee-is-sticky");
          galleryWrapper.style.height = "auto"; // Höhe wieder normalisieren
        }
      }
    };

    // Überwache das Scrollen auf dem Handy
    window.addEventListener("scroll", onScroll);
    
  }, 2000); // 2000 Millisekunden = 2 Sekunden Wartezeit für den Aufbau der App
});